import React from "react";
function Tooltip({ value,max }) {
  return (
    <div
      style={{
        backgroundColor: "rgba(0,0,0,0.1)",
        width: "28px",
        height: "28px",
        display: "flex", // Add this line
        alignItems: "center", // Center vertically
        justifyContent: "center", // Center horizontally
        borderRadius: "45px",
        marginLeft: `${230*(value/max)}px`,
        textAlign: "center",
        position:"absolute",
        zIndex:100,
        marginTop:"-24px"
      }}
    >
      <p style={{ color: "#000", fontSize: "70%", margin: 0 }}>{value}</p>
    </div>
  );
}
export default Tooltip;
